import { Injectable } from "@angular/core"

import { CreatePromotionDto, FindPromotionDto, PageResultDto, PromotionDetailDto, PromotionDto, UpdatePromotionDto } from "../dto"
import { HttpService } from "./http.service"

@Injectable()
export class PromotionService {
  constructor(
    private httpService: HttpService) {
  }

  async find({ limit, offset, searchText }: FindPromotionDto) {
    return await this.httpService.get<PageResultDto<PromotionDto>>('/admin/promotion', { limit, offset, searchText })
  }

  async findOne(id: string) {
    return await this.httpService.get<PromotionDetailDto>(`/admin/promotion/${id}`)
  }

  async create(createPromotionDto: CreatePromotionDto) {
    return await this.httpService.post<PromotionDto>('/admin/promotion', createPromotionDto)
  }

  async update(id: string, updatePromotionDto: UpdatePromotionDto) {
    return await this.httpService.put<boolean>(`/admin/promotion/${id}`, updatePromotionDto)
  }

  async delete(id: string) {
    return await this.httpService.delete<boolean>(`/admin/promotion/${id}`)
  }

  async updateThumbnail(id: string, fileId: string) {
    return await this.httpService.put<boolean>(`/admin/promotion/${id}/thumbnail`, { fileId })
  }

  async sendNotification(id: string) {
    return await this.httpService.post<boolean>(`/admin/promotion/${id}/notification`)
  }

  async setEnabled(id: string, enabled: boolean) {
    if (enabled) {
      return await this.httpService.patch<Boolean>(`/admin/promotion/${id}/enable`)
    }

    return await this.httpService.patch<Boolean>(`/admin/promotion/${id}/disable`)
  }

  async publish(id: string) {
    return await this.httpService.patch<Boolean>(`/admin/promotion/${id}/publish`)
  }
}
